import React from "react";

// @material-ui/core components
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import {makeStyles} from "@material-ui/core/styles";
// @material-ui/icons
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
// core components
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Info from "components/Typography/Info.js";
import Danger from "components/Typography/Danger.js";
import Success from "components/Typography/Success.js";
import Warning from "components/Typography/Warning.js";
import Rose from "components/Typography/Rose.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

import copy from 'copy-to-clipboard';
import {string} from "prop-types";
import intl from "react-intl-universal";


const useStyles = makeStyles(styles);

export default function UserChangeRotatingCard(props) {
	const [activeRotate1, setActiveRotate1] = React.useState("");
	const classes = useStyles();
	React.useEffect(() => {
		if (window) {
			window.addEventListener("resize", addStylesForRotatingCards);
		}
		addStylesForRotatingCards();
		return function cleanup() {
			if (window) {
				window.removeEventListener("resize", addStylesForRotatingCards);
			}
		};
	});
	const addStylesForRotatingCards = () => {
		var rotatingCards = document.getElementsByClassName(classes.cardRotate);
		for (let i = 0; i < rotatingCards.length; i++) {
			var rotatingCard = rotatingCards[i];
			var cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
			var cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			var rotatingWrapper = rotatingCard.parentElement;
			var cardWidth = rotatingCard.parentElement.offsetWidth;
			var cardHeight = rotatingCard.children[0].children[0].offsetHeight;
			rotatingWrapper.style.height = cardHeight + "px";
			rotatingWrapper.style["margin-bottom"] = 30 + "px";
			cardFront.style.height = "unset";
			cardFront.style.width = "unset";
			cardBack.style.height = "unset";
			cardBack.style.width = "unset";
			cardFront.style.height = cardHeight + 35 + "px";
			cardFront.style.width = cardWidth + "px";
			cardBack.style.height = cardHeight + 35 + "px";
			cardBack.style.width = cardWidth + "px";
		}
	};


	return (
		<GridItem xs={12} sm={6} md={6} lg={6}
				  style={{marginTop: '-32px', paddingBottom: '24px', overflow: "hidden"}}>
			<div
				className={
					classes.rotatingCardContainer +
					" " +
					classes.manualRotate +
					" " +
					activeRotate1
				}

			>
				<Card className={classes.cardRotate}>
					<div className={classes.front}
						 style={{boxShadow: "0px 0px 0px #000000", backgroundColor: '#00000000'}}>
						<Card color="primary">
							<CardBody>
								<Warning>
									<h5 className={classes.cardCategorySocialWhite}>
										<BubbleChartIcon/> {intl.get('change_item')}
									</h5>
								</Warning>
								<h2 className={classes.cardTitleWhite + " " + classes.textCenter}>
									{props.userInvitationCountEffective}
								</h2>
							</CardBody>
							<CardFooter>
								<GridItem xs={12} sm={12} md={12} lg={6}
										  className={classes.textCenter}>
									<Button color="rose" round
											onClick={props.userChange.bind(this)}>
										{intl.get('exchange')}
									</Button>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} lg={6}
										  className={classes.textCenter}>
									<Button color="info" round onClick={() =>
										setActiveRotate1(classes.activateRotate)
									}>
										{intl.get('exchange')}?
									</Button>
								</GridItem>
							</CardFooter>
						</Card>
					</div>
					<div className={classes.back} style={{boxShadow: "0px 0px 0px #000000"}}>
						<Card color="primary">
							<CardBody>
								<Info>
									<h5 className={classes.cardCategorySocialWhite + " " + classes.textLeft}>
										<BubbleChartIcon/> {intl.get('exchange')}

									</h5>
								</Info>
								<br/>
								<b className={" " + classes.textCenter}>
									{intl.get('exchange_info')}
								</b>
							</CardBody>
							<CardFooter>
								<GridItem xs={12} sm={12} md={12} lg={6}>
								</GridItem>
								<GridItem xs={12} sm={12} md={12} lg={6}>
									<Button color="info" round onClick={() => setActiveRotate1("")}>
										Back
									</Button>
								</GridItem>
							</CardFooter>
						</Card>
					</div>
				</Card>
			</div>
		</GridItem>
	);
}
